import { Market } from './Market';

export interface MarkerType {
  key: string;
  name: string;
  label: string;
  icon?: string;
}

class MarkerTypes {
  MARKET: MarkerType = {
    key: 'MARKET',
    name: 'market',
    label: 'Market'
  };

  SUBJECT: MarkerType = {
    key: 'SUBJECT',
    name: 'subject',
    label: 'Subject'
  };

  RENT_COMP: MarkerType = {
    key: 'COMPARISON',
    name: 'comparison',
    label: 'Comps'
  };

  SALES_COMP: MarkerType = {
    key: 'SALES_COMPARISON',
    name: 'comparison',
    label: 'Comps'
  };

  CONSTRUCTION: MarkerType = {
    key: 'CONSTRUCTION',
    name: 'construction',
    label: 'Construction Pipeline'
  };

  NONE: MarkerType = {
    key: 'NONE',
    name: 'none',
    label: 'None'
  };

  sortByPosition<T extends Market>(l: T, r: T): number {
    return (+l.position) - (+r.position);
  }
}

export const MARKER_TYPE = new MarkerTypes();



// WEBPACK FOOTER //
// ./src/app/core/model/Marker.ts